import React, { useEffect } from 'react';
import { useField, useFormikContext } from 'formik';
import PropTypes from 'prop-types';

/**
 * This component adds a hidden amount field too a donation form
 * that monitors the `amount-holder` field, and updates itself
 * with the penny-value of that field
 */
const HiddenAmountField = (props) => {
  const { defaultPennyValue, name } = props;
  const {
    values: { 'amount-holder': amountHolder },
    touched: { 'amount-holder': touchedAmountHolder },
    setFieldValue,
  } = useFormikContext();
  const [field] = useField(props);

  useEffect(() => {
    if (amountHolder) {
      const amountInPennies = (amountHolder * 100).toString();
      setFieldValue(name, amountInPennies);
    } else {
      const amountInPennies = defaultPennyValue.toString();
      setFieldValue(name, amountInPennies);
    }
  }, [
    amountHolder,
    touchedAmountHolder,
    setFieldValue,
    name,
    defaultPennyValue,
  ]);

  return <input type="hidden" {...field} />;
};

HiddenAmountField.propTypes = {
  defaultPennyValue: PropTypes.number,
  name: PropTypes.string.isRequired,
};

export default HiddenAmountField;
